import WindowSills from "./WindowSills";

export default WindowSills